import { ProjectAttachmentModel } from 'types/models/AttachmentModel';

import { BaseService } from './baseService';

class ProjectAttachmentService extends BaseService<ProjectAttachmentModel> {
  controllerName = 'projectattachment';
}

export const projectAttachmentService = new ProjectAttachmentService();
